import { render, staticRenderFns } from "./LayoutAnalytics.vue?vue&type=template&id=2980c1e8&scoped=true&"
import script from "./LayoutAnalytics.vue?vue&type=script&lang=js&"
export * from "./LayoutAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAnalytics.vue?vue&type=style&index=0&id=2980c1e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2980c1e8",
  null
  
)

export default component.exports